<template>
  <v-card>
    <v-card-title class="pb-0">
      <h1 class="headline">
        Редактирование Водителя
      </h1>
    </v-card-title>
    <v-card-text class="pt-2">
      <v-form v-model="isValid">
        <v-layout column>
          <v-flex xs12>
            <v-layout row>
              <v-flex xs4>
                <TitleTextField
                  v-model="name"
                  :required="true"
                  :rules="[rules.required, rules.min]"
                  label="Имя*"
                  class="mx-2 mb-3"
                  @input="isChanged = true"
                />
              </v-flex>
              <v-flex xs4>
                <TitleTextField
                  v-model="surname"
                  :required="true"
                  :rules="[rules.required, rules.min]"
                  label="Фамилия*"
                  class="mx-2 mb-3"
                  @input="isChanged = true"
                />
              </v-flex>
              <v-flex xs4>
                <app-reference
                  v-model="carrier"
                  class="mx-2 mb-3"
                  resource="carriers"
                  component-name="Carrier"
                  label="Перевозчик*"
                  :rules="[v => !!v || '']"
                  :outline="true"
                  :height-field="44"
                  @input="isChanged = true"
                />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs6>
                <EditableList
                  v-model="phones"
                  class="mx-2 mb-3"
                  label="Телефон"
                  :mask="getMask('phone')"
                  :hint="hint"
                  filter="phoneInternational"
                  outline
                  height="44"
                  title="Редактирование номеров телефонов"
                  data-test="phone"
                  @change="changePhones"
                />
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="viber"
                  class="mx-2 mb-3"
                  label="Viber"
                  :mask="getMask('phone')"
                  outline
                  height="52"
                  @input="isChanged = true"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout class="mt-3">
          <v-btn
            small
            color="primary"
            :disabled="!(isValid && isChanged) || isRemoved || loading"
            @click="submit(false)"
          >
            Сохранить
          </v-btn>
          <v-btn
            v-if="!isModal"
            small
            color="primary"
            :disabled="!(isValid && isChanged) || isRemoved || loading"
            @click="saveAndClose"
          >
            Сохранить и закрыть
          </v-btn>
          <v-btn
            small
            @click="cancel"
          >
            Отмена
          </v-btn>
          <v-spacer />
          <v-btn
            v-if="id!==0"
            small
            :color="isRemoved ? 'success' :'error'"
            @click="changeRemovedState"
          >
            {{ isRemoved ? "Восстановить" : "Удалить" }}
          </v-btn>
        </v-layout>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { NestedEditorsEventBus } from "../../components/nested-editors/nested-editors-event-bus.js";
import mixin from "./../../mixins/confirm-cancel-changes.js";
import * as driversApi from "../../backend/driversApi.js";

export default {
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      isValid: false,
      isChanged: false,
      rules: {
        empty: (v) => !!v || "",
        required: (v) => !!v || "Поле обязательно к заполнению",
        min: (v) =>
          v.length >= 3 || "Поле должно содержать не менее 3-х символов",
      },
      resource: "drivers",
      addMessage: "Водитель добавлен",
      editMessage: "Водитель изменен",
      name: "",
      surname: "",
      carrier: null,
      phones: [],
      viber: "",
      isRemoved: false,
      hint: "Номер телефона уже добавлен",
      loading: false,
    };
  },
  computed: {
    isModal() {
      let parent = this.$parent;
      while (parent) {
        if (parent.$options._componentTag === "NestedEditors") {
          return true;
        }
        parent = parent.$parent;
      }
      return false;
    },
  },
  created() {
    if (+this.id) {
      this.getData();
    }
  },
  mounted() {
    if (this.isModal) {
      NestedEditorsEventBus.$emit("modal-editor-mounted");
    }
  },
  methods: {
    async getData() {
      const res = await driversApi.getDriver(this.resource, this.id);
      this.name = res.data.Name;
      this.surname = res.data.Surname;
      this.phones = res.data.Phones;
      this.viber = res.data.Viber;
      this.carrier = res.data.Carrier
        ? {
          id: res.data.Carrier.Id,
          title: res.data.Carrier.Title,
        }
        : null;
      this.isRemoved = res.data.IsRemoved;
    },
    async submit(closeAfterSubmit) {
      const driver = {
        name: this.name,
        surname: this.surname,
        phones: this.phones,
        viber: this.viber,
        carrierId: this.carrier.id,
      };

      if (this.id && this.id > 0) {
        this.loading = true;
        await driversApi.updateDriver(this.resource, this.id, driver);
        this.showInfo(this.editMessage);
        this.isChanged = false;
        this.loading = false;
        if (closeAfterSubmit) {
          this.$router.go(-1);
        }
        if (this.isModal) {
          NestedEditorsEventBus.$emit("create", this.id);
        }
        this.getData();
      } else {
        this.loading = true;
        const res = await driversApi.createDriver(this.resource, driver);
        this.showInfo(this.addMessage);
        this.isChanged = false;
        this.loading = false;
        if (this.isModal) {
          NestedEditorsEventBus.$emit("create", res.data);
        } else {
          this.$router.replace(`/${this.resource}/${res.data}`);
          if (closeAfterSubmit) {
            this.$router.go(-1);
          }
        }
      }
    },
    cancel() {
      if (this.isModal) {
        NestedEditorsEventBus.$emit("close");
      } else {
        this.$router.go(-1);
      }
    },
    async saveAndClose() {
      await this.submit(true);
    },
    async changeRemovedState() {
      await driversApi.changeRemovedState(
        this.resource,
        this.id,
        this.isRemoved,
      );
      this.isRemoved = !this.isRemoved;
    },
    changePhones(val) {
      this.isChanged = true;
      this.phones = val;
    },
    getMask(controlType) {
      switch (controlType) {
        case "phone":
          return "+##(###)###-##-##";
        default:
          return "";
      }
    },
    resetLoaders() {
      this.loading = false;
    },
  },
};
</script>
